import React from 'react';
import { BetaFeature } from '../@types/BetaFeature.type';
import { FEATURE_FLAGS, ROUTES } from '../constants/routes';
import DownloadPackets from './pages/downloadPackets/DownloadPackets';

/**
 * Registry of beta features.
 * To add a new beta feature: create the page under src/beta/pages and add an entry here.
 * To graduate a feature (GA for everyone), remove its `flag`.
 */
export const BETA_FEATURES: BetaFeature[] = [
  {
    id: 'download-packets',
    label: 'Download Packets',
    path: ROUTES.BETA_DOWNLOAD_PACKETS,
    flag: FEATURE_FLAGS.JETSTREAM_BETA,
    element: <DownloadPackets />,
  },
];

export const getBetaFlagNames = (features: BetaFeature[] = BETA_FEATURES) =>
  Array.from(
    new Set(
      features
        .map((feature) => feature.flag)
        .filter((flag): flag is string => Boolean(flag)),
    ),
  );
